
//REST API ENDPOINT
export const GRAPH_HOSTNAME = "https://orientationapi.icep.co.za" //"https://tut-orientation-api.com"

//FILE TRANSFER ENDPOINT
export const APP_HOSTNAME = "https://orientationapi.icep.co.za" //"https://tut-orientation-api.com"

//SOCKETIO ENDPOINT
export const SOCK_HOSTNAME = "http://ec2-54-234-88-147.compute-1.amazonaws.com"

//Apache FTP (SMTP,PDFRender,Frontend)
export const APACHE_HOST = "https://orientationapi.icep.co.za" //"https://tut-orientation-api.com/Orientation_Final-BE/extra"

//New change
//3.88.53.196/Orientation_Final-BE/extra


